<template lang="pug">
b-modal#bonusIssue(
  ref="bonusIssue"
  :title="$t('ui.combine.bonus_issue')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row
      //- small {{ provider_list }} 
      //- small {{ pList }}
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.account_id')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="account_id"
            required
            type="text"
            :dirty="$v.account_id.$dirty"
            :error="$v.account_id.$error"
            v-model.trim.lazy="$v.account_id.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.bonus_name')").mb-0
          DebounceInput(
            size="sm"
            ref="bonus_name"
            required
            type="text"
            :dirty="$v.bonus_name.$dirty"
            :error="$v.bonus_name.$error"
            v-model.trim.lazy="$v.bonus_name.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.bonus_name" :name="$t('ui.bonus_name')")
    div.row
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.bonus_desc')").mb-0
          DebounceInput(
            size="sm"
            ref="bonus_desc"
            type="text"
            v-model="bonus_desc"
            :disabled="loading"
          )
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.bonus_amount')").mb-0
          DebounceInput(
            size="sm"
            ref="bonus_amount"
            required
            type="text"
            :dirty="$v.bonus_amount.$dirty"
            :error="$v.bonus_amount.$error"
            v-model.trim.lazy="$v.bonus_amount.$model"
            :disabled="loading"
          )
          //- span.small.text-info {{ $t("message.tooltips_bonus_issue") }}
          ValidateResult(:value="$v.bonus_amount" :name="$t('ui.bonus_amount')")
    b-form-group(:label="$t('ui.attach_promo')").mb-2
      div.d-flex
        label.custom-switch
          input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="attach_promo" disabled)
          span.custom-switch-indicator
        //- label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
        //-   input.switch-input(
        //-     type="checkbox"
        //-     required
        //-     v-model="attach_promo"
        //-     :disabled="loading"
        //-   )
        //-   span.switch-slider(:data-checked='on' :data-unchecked='off')
  div.row
    div.col-sm-12.col-md-6.col-lg-6
      b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 42vh;" v-if="attach_promo").mb-0
        table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
          tr
            th.text-center.col-checkbox(colspan=2)
              .d-flex
                .custom-checkbox.custom-control
                  input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelected" data-checkbox-role="dad" @change="selectAll(0,$event)" v-model="allSelected[0]" :disabled="loading")
                  label.custom-control-label(for='all-provider') {{ $t('ui.all') }}
                template(v-for="(cat, index) in providerCatList")
                  .custom-checkbox.custom-control
                    input.custom-control-input(
                      type="checkbox"
                      :id="'all-' + cat.toLowerCase()"
                      v-model="allSelected[index + 1]"
                      @change="selectAll(index + 1,$event)"
                      :disabled="loading"
                    )
                    label.custom-control-label(:for="'all-' + cat.toLowerCase()") {{ $t('ui.' + cat.toLowerCase()) }}
          tr(v-for='(p, index) in pList')
            td.text-center.col-checkbox(width="5%")
              .custom-checkbox.custom-control
                input.custom-control-input(:id="'all-' + index" type='checkbox' v-model="provider_list" :value='p.value' :disabled="loading")
                label.custom-control-label(:for="'all-' + index") &nbsp;
            td {{ p.text }}
      ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
    div.col-sm-12.col-md-6.col-lg-6
      b-form-group(:label="$t('ui.criteria')" v-if="attach_promo").mb-0
        VipCriteriaList(
          ref="criteria"
          size="sm"
          required
          type="array"
          :dirty="$v.criteria.$dirty"
          :error="$v.criteria.$error"
          v-model.trim.lazy="$v.criteria.$model"
          :disabled="loading"
          :hideOpt="hideOpt"
          @input="resetValue"
        )
        ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
      b-form-group(:label="$t('ui.rollover')" v-if="attach_promo").mb-0
        DebounceInput(
          size="sm"
          ref="rollover"
          type="text"
          :dirty="$v.rollover.$dirty"
          :error="$v.rollover.$error"
          v-model.trim.lazy="$v.rollover.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
      b-form-group(:label="$t('ui.withhold_bonus')" v-if="attach_promo && criteria == 'WIN'").mb-2
        div.d-flex
          label.custom-switch
            input.custom-switch-input(
              type="checkbox"
              required
              :dirty="$v.withhold_bonus.$dirty"
              :error="$v.withhold_bonus.$error"
              v-model.trim.lazy="$v.withhold_bonus.$model"
              :disabled="loading"
            )
            span.custom-switch-indicator
          //- label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
          //-   input.switch-input(
          //-     type="checkbox"
          //-     required
          //-     :dirty="$v.withhold_bonus.$dirty"
          //-     :error="$v.withhold_bonus.$error"
          //-     v-model.trim.lazy="$v.withhold_bonus.$model"
          //-     :disabled="loading"
          //-   )
          //-   span.switch-slider(:data-checked='on' :data-unchecked='off')
        ValidateResult(:value="$v.withhold_bonus" :name="$t('ui.withhold_bonus')")
      b-form-group(:label="$t('ui.max_withdraw_amount')" v-if="attach_promo").mb-0
        DebounceInput(
          size="sm"
          ref="max_withdraw_amount"
          required
          type="text"
          :dirty="$v.max_withdraw_amount.$dirty"
          :error="$v.max_withdraw_amount.$error"
          v-model.trim.lazy="$v.max_withdraw_amount.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
      b-form-group(:label="$tc('ui.remark')" v-if="attach_promo").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          v-model.trim.lazy="$v.remark.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, minValue, numeric, helpers, decimal, requiredIf, integer } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: "",
      bonus_name: "",
      bonus_desc: "",
      bonus_amount: "",
      attach_promo: true,
      criteria: "",
      rollover: "",
      withhold_bonus: false,
      max_withdraw_amount: 0,
      remark: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      hideOpt: ['DEPOSIT'],
      provider_list: [],
      providerList: [],
      allSelected: {},
      pList: [],
      providerCatList: [],
      prefixMap: {}
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      // minLength: minLength(6),
      maxLength: maxLength(20)
    },
    bonus_name: {
      required
    },
    bonus_amount: {
      required,
      decimal,
      minValue: minValue(1)
    },
    criteria: {
      required : requiredIf(function () {
        return this.attach_promo;
      }),
    },
    rollover: {
      required : requiredIf(function () {
        return this.attach_promo;
      }),
      integer
    },
    withhold_bonus: {
      required : requiredIf(function () {
        return this.attach_promo && this.criteria == 'WIN';
      })
    },
    max_withdraw_amount: {
      required : requiredIf(function () {
        return this.attach_promo;
      }),
      decimal
    },
    remark: {
      required : requiredIf(function () {
        return this.attach_promo;
      }),
    },
    provider_list: {
      atLeastOneProvider : requiredIf(function () {
        return this.attach_promo;
      }),
      minLength: minLength(1)
    }
  },
  watch : {
    provider_list: {
      handler(newValue) {
        const val = (newValue.length === this.pList.length && this.pList.length > 0)

        const checkGroupSelected = prefix => {
          const items = this.pList.filter(item => item.category === prefix)
          return items.length > 0 && items.every(item => newValue.includes(item.value))
        }

        Object.keys(this.allSelected).forEach(k => {
          const num = Number(k)

          // master
          if (num === 0) {
            this.$set(this.allSelected, 0, val)
          }
          // others
          else {
            this.$set(this.allSelected, num, checkGroupSelected(this.providerCatList[num-1]))
          }
        })
      },
      deep: true
    }
  },
  methods: {
    resetValue() {
      if (this.criteria == "TURNOVER")
        this.withhold_bonus = false;
    },
    selectAll: function(mode, evt) {
      const prefixMap = this.prefixMap

      // If mode is 0 (master checkbox toggled), sync all individual selections
      if (mode === 0) {
        Object.keys(this.allSelected).forEach(k => {
          this.$set(this.allSelected, k, evt.target.checked)
        })

        if (!this.allSelected[0]) {
          this.provider_list = [];
          return; // Exit early if unchecking all
        }

        // Select all providers with matching prefixes
        const allPrefixes = Object.values(prefixMap);
        this.provider_list = this.pList
          .filter(item => allPrefixes.some(prefix => item.category == prefix))
          .map(item => item.value);

        return;
      }

      const checked = evt.target.checked
      this.$set(this.allSelected, mode, checked)

      // Individual group checkbox toggled
      const prefix = prefixMap[mode];
      const groupItems = this.pList.filter(item => item.category == prefix);
      const groupValues = groupItems.map(item => item.value);

      if (this.allSelected[mode]) {
        // Add group values to provider_list without duplicates
        this.provider_list = Array.from(new Set([...this.provider_list, ...groupValues]));
      } else {
        // Remove only group values
        this.provider_list = this.provider_list.filter(val => !groupValues.includes(val));
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = '';

        if (this.attach_promo)
          url = config.bonusIssuePromoUrl();
        else
          url = config.bonusIssueUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          bonus_name: this.bonus_name,
          bonus_desc: this.bonus_desc,
          bonus_amount: this.bonus_amount
        };

        if (this.attach_promo) {
          json.criteria = this.criteria;
          json.rollover = this.rollover;
          json.withhold_bonus = this.criteria == "TURNOVER" ? false : this.withhold_bonus;
          json.max_withdraw_amount = this.max_withdraw_amount;
          json.remark = this.remark;
          if (this.provider_list.length != this.pList.length)
            json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();
        }

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.bonusIssue.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "bonus_issue", this.feedback.status);
                  this.$refs.bonusIssue.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getPList() {
      let list = this.providerList;

      let result = [];

      for(var i = 0; i < list.length; i++) {
        result.push({value: list[i].provider_code, text: list[i].provider_name, checked: false, category: list[i].category});
      }
      this.pList = result;
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        is_free: false,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerList = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                this.setCategory();
                this.getPList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setCategory() {
      // Build unique category list using Set (avoid duplicates)
      const catsSet = new Set()
      for (const item of this.providerList) {
        // add each category into Set (Set auto removes duplicates)
        catsSet.add(item.category)
      }

      // convert Set back to Array so we can use v-for easily
      this.providerCatList = Array.from(catsSet)

      // create checkbox state object
      // key 0 = master "select all" checkbox (initially false = unchecked)
      const obj = { 0: false }

      // for each category index, set initial checkbox state for that group also false
      this.providerCatList.forEach((_, i) => {
        obj[i + 1] = false  // i+1 means group number starting from 1
      })

      this.allSelected = obj

      this.prefixMap = this.providerCatList.reduce((o, v, idx) => {
        o[idx + 1] = v
        return o
      }, {})
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.bonus_name = "";
      this.bonus_desc = "";
      this.bonus_amount = "";
      this.attach_promo = true;
      this.criteria = "";
      this.rollover = "";
      this.withhold_bonus = false;
      this.max_withdraw_amount = 0;
      this.remark = "";
      this.providerList = [];
      this.provider_list = [];
      this.pList = [];
      this.allSelected = false;
      this.allSelected1 = false;
      this.allSelected2 = false;
      this.allSelected3 = false;
      this.getProviderList();
      this.$refs.bonus_name.$el.focus();
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.$set(this.allSelected, 0, false)
    }
  }
};
</script>
